import ApiService from './api.service'
import { TokenService } from './token.service'

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorCode = errorCode
  }
}

const AuthService = {
  requestEmailToken: async function(email) {
    const requestData = {
      method: 'post',
      url: 'auth/login',
      data: {
        grant_type: 'email',
        email: email
      }
    }

    try {
      const response = await ApiService.customRequest(requestData)
      return response.data
    } catch (e) {
      throw new AuthenticationError(e.response.status, e.response.data.error)
    }
  },

  requestJWT: async function(token) {
    const requestData = {
      method: 'post',
      url: 'auth/token',
      data: {
        grant_type: 'token',
        token: token
      }
    }

    try {
      const response = await ApiService.customRequest(requestData)

      TokenService.saveToken(response.data.access_token)
      TokenService.saveRefreshToken(response.data.refresh_token)

      ApiService.setHeader()
      ApiService.mount401Interceptor()

      return response.data
    } catch (e) {
      throw new AuthenticationError(e.response.status, e.response.data.error)
    }
  },

  refreshToken: async function() {
    const requestData = {
      method: 'post',
      url: 'auth/refresh',
      data: {
        grant_type: 'refresh'
      }
    }

    try {
      ApiService.setRefreshHeader()
      const response = await ApiService.customRequest(requestData)

      TokenService.saveToken(response.data.access_token)
      TokenService.saveRefreshToken(response.data.refresh_token)
      ApiService.setHeader()

      return response.data
    } catch (e) {
      deleteTokens()
      throw new AuthenticationError(e.response.status, e.response.data.error)
    }
  },

  logout: async function() {
    const refreshToken = TokenService.getRefreshToken()
    if (TokenService.isValid(refreshToken)) {
      try {
        const requestData = {
          method: 'post',
          url: 'auth/logout',
          headers: {
            Authorization: `Bearer ${TokenService.getRefreshToken()}`
          }
        }
        ApiService.setRefreshHeader()
        await ApiService.customRequest(requestData)
      } catch (e) {
        throw new AuthenticationError(e.response.status, e.response.data.error)
      }
    }
    deleteTokens()
  },

  getAccount: async function() {
    try {
      const response = await ApiService.getAccount()
      return response.data
    } catch (e) {
      throw new AuthenticationError(e.response.status, e.response.data.error)
    }
  }
}

function deleteTokens() {
  TokenService.removeToken()
  TokenService.removeRefreshToken()
  ApiService.unmount401Interceptor()
  ApiService.removeHeader()
}

export default AuthService

export { AuthService, AuthenticationError }
